import { AppShell } from "@/components/layout/AppShell";
import { GarageHeroCard } from "@/components/garage/GarageHeroCard";
import { QuickActionsGrid } from "@/components/garage/QuickActionsGrid";
import { useVINs, VINUnit } from "@/hooks/useUnits";
import { Card } from "@/components/ui/card";
import { Clock, ChevronRight } from "lucide-react";

const mockUnit: VINUnit = {
  vin: "1JCYT2B26R1000042",
  serialNumber: "YTB2260042",
  secondaryVin: "",
  make: "Jayco",
  model: "Terrain",
  modelLine: "Terrain",
  modelCode: "T26",
  modelYear: "2026",
  unitType: "MH",
  brandSegment: "Jayco",
  warrantyStatus: "Active",
  retailSaleDate: "",
  unitRegistrationDate: "2025-12-20",
  warrantyExpirationDate: "2028-12-20",
  warrantyExpirationMileage: "36000",
  unitStatus: "Active",
  offlineDate: "",
  floorplan: "19A - Lithium",
  mappedFields: {
    vin: true, serialNumber: true, make: true, model: true,
    modelLine: true, modelYear: true, unitType: true,
    warrantyStatus: true, offlineDate: false,
    dealerName: true, dealerCode: true,
  },
};

const Index = () => {
  const { vins, isLoading } = useVINs(undefined, undefined, 1, 1);
  const myUnit = vins[0] || (!isLoading ? mockUnit : undefined);

  return (
    <AppShell>
      <GarageHeroCard unit={myUnit} isLoading={isLoading} />
      <QuickActionsGrid />

      {/* Recent Activity placeholder */}
      <div className="px-4 mt-6 mb-4">
        <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-3">
          Recent Activity
        </h3>
        <Card className="divide-y divide-border">
          {["Warranty registered", "Oil change logged", "Service campaign notice"].map((item, i) => (
            <button
              key={i}
              className="flex items-center gap-3 w-full px-4 py-3 text-left hover:bg-accent/50 transition-colors"
            >
              <div className="p-1.5 rounded-full bg-primary/10 text-primary shrink-0">
                <Clock className="h-4 w-4" />
              </div>
              <span className="text-sm text-foreground flex-1">{item}</span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>
          ))}
        </Card>
      </div>
    </AppShell>
  );
};

export default Index;
